import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {
  ToastContainer,
  Toast,
  Modal,
  Form,
  Button,
  CloseButton,
  Badge,
  InputGroup
} from 'react-bootstrap'
import { connect } from 'react-redux'
import config from '../../../config'
import axios from 'axios'

function Contacts({ authToken }) {
  const [searchResult, setSearchResult] = useState([])
  const [search, setSearch] = useState('')
  const [show, setShow] = useState(false)
  const [loadingChat, setLoadingChat] = useState(false)
  const [selectedChat, setSelectedChat] = useState()
  const [chats, setChats] = useState([])
  const [groupChatName, setGroupChatName] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedUsers, setSelectedUsers] = useState([])
  const [showToast, setShowToast] = useState(false)
  const [toastMessage, setToastMessage] = useState('')
  const [toastVariant, setToastVariant] = useState('danger')

  const handleShow = () => setShow(true)
  const handleClose = () => setShow(false)

  const navigate = useNavigate()

  // Get logged-in user info
  const loggedUser = JSON.parse(localStorage.getItem('userInfo'))

  // Toast message handler
  const displayToast = (message, variant = 'danger') => {
    setToastMessage(message)
    setToastVariant(variant)
    setShowToast(true)
    setTimeout(() => setShowToast(false), 2000)
  }

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const head = { headers: { Authorization: `Bearer ${authToken}` } }
        const { data } = await axios.get(
          `${config.devapi}user?search=${search}`,
          head
        )
        // Filter out the logged-in user from search results
        const filteredResults = data.filter(
          user => user._id !== loggedUser?._id
        )
        setSearchResult(filteredResults)
      } catch (error) {
        console.error('Failed to load search results', error)
        displayToast('Failed to load search results', 'danger')
      }
    }
    fetchUsers()
  }, [search, authToken, loggedUser?._id])

  // Handle search in the main component
  const handleMainSearch = event => {
    setSearch(event.target.value)
  }

  // Handle search in the modal
  const handleModalSearch = event => {
    setSearchQuery(event.target.value)
    // Search users with the same query in the modal
    setSearch(event.target.value)
  }

  const handleAddUser = user => {
    if (selectedUsers.find(u => u._id === user._id)) {
      displayToast('User already selected!', 'warning')
      return
    }
    setSelectedUsers([...selectedUsers, user])
  }

  const handleDelete = user => {
    setSelectedUsers(selectedUsers.filter(u => u._id !== user._id))
  }

  const handleSubmit = async () => {
    if (!groupChatName || selectedUsers.length === 0) {
      displayToast('Enter a group Chat Name or select Users', 'warning')
      return
    }
    try {
      const head = { headers: { Authorization: `Bearer ${authToken}` } }
      await axios.post(
        `${config.devapi}chat/group`,
        {
          name: groupChatName,
          users: JSON.stringify(selectedUsers.map(u => u._id))
        },
        head
      )
      displayToast('New Group Chat Created!', 'success')
      setGroupChatName('')
      setSearchQuery('')
      setSelectedUsers([])
      setShow(false)

      setTimeout(() => {
        navigate('/dashboard')
      }, 1000)
    } catch (error) {
      console.error('Failed to create chat', error)
      displayToast('Failed to create chat', 'warning')
    }
  }

  const handleFunction = async userId => {
    try {
      setLoadingChat(true)
      const headers = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        }
      }
      const { data } = await axios.post(
        `${config.devapi}chat`,
        { userId },
        headers
      )
      setChats(prevChats =>
        prevChats.some(chat => chat._id === data._id)
          ? prevChats
          : [data, ...prevChats]
      )
      setSelectedChat(data)
      navigate(`/dashboard?chatId=${data._id}`)
      setLoadingChat(false)
    } catch (error) {
      displayToast(
        error.response?.data?.message || 'Error fetching the chat',
        'danger'
      )
      setLoadingChat(false)
    }
  }

  // phoneNumber handle
  const formatPhoneNumber = phoneNumber => {
    if (!phoneNumber) return ''

    // Handle phone numbers with country code
    if (phoneNumber.startsWith('91') && phoneNumber.length >= 12) {
      return `+${phoneNumber.substring(0, 2)} ${phoneNumber.substring(
        2,
        7
      )} ${phoneNumber.substring(7)}`
    }

    // For other formats or shorter numbers, add basic formatting
    if (phoneNumber.length === 10) {
      return `${phoneNumber.substring(0, 5)}-${phoneNumber.substring(5)}`
    }
    return phoneNumber
  }

  return (
    <>
      <ToastContainer
        className="p-3"
        position="middle-center"
        style={{ zIndex: 1060 }}
      >
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          bg={toastVariant}
          delay={2000}
          autohide
        >
          <Toast.Header closeButton>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="appHeader text-light">
        <div className="left">
          <Link to="/dashboard" className="item">
            <a href="" className="headerButton goBack">
              <ion-icon name="arrow-back-outline"></ion-icon>
            </a>
          </Link>
        </div>
        <div className="tit position-relative">
          Select contact
          <footer id="contact-list">{searchResult.length} contacts</footer>
        </div>
      </div>

      <ul
        className="listview image-listview"
        style={{
          height: 'calc(100dvh - var(--header-height) - 2px)',
          overflowX: 'hidden',
          overflowY: 'auto'
        }}
      >
        <li>
          <div className="item" onClick={handleShow}>
            <div className="icon-box" style={{ backgroundColor: '#e0e0e0' }}>
              <ion-icon name="people-outline"></ion-icon>
            </div>
            <div className="">
              <div>New group</div>
            </div>
          </div>
          <Modal show={show} fullscreen onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Create New Group</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-2">
                  <Form.Control
                    type="text"
                    placeholder="Group Name"
                    value={groupChatName}
                    onChange={e => setGroupChatName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-2">
                  <InputGroup>
                    <InputGroup.Text>
                      <ion-icon name="search-outline"></ion-icon>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search Users eg: John, Jane"
                      value={searchQuery}
                      onChange={handleModalSearch}
                    />
                  </InputGroup>
                </Form.Group>
                <div className="mb-3">
                  {selectedUsers.map(user => (
                    <Badge
                      pill
                      bg="primary"
                      className="me-2 p-2 mb-1"
                      key={user._id}
                    >
                      {user.name}
                      <CloseButton onClick={() => handleDelete(user)} />
                    </Badge>
                  ))}
                </div>
                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {searchResult.map(user => (
                    <div
                      key={user._id}
                      className="d-flex align-items-center my-2 px-2 border-bottom pb-2"
                      onClick={() => handleAddUser(user)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={user.pic}
                        alt="user-icon"
                        className="rounded-circle me-2"
                        width="36"
                        height="36"
                      />
                      <div className="d-flex flex-column">
                        <label>{user.name}</label>
                        <label>
                          <b>Mobile No: </b>
                          {formatPhoneNumber(user.phone)}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
              <Button variant="primary" onClick={handleClose}>
                Cancel
              </Button>
              <Button variant="success" onClick={handleSubmit}>
                Create Group
              </Button>
            </Modal.Footer>
          </Modal>
        </li>
        <li>
          <div className="item">
            <div className="icon-box" style={{ backgroundColor: '#e0e0e0' }}>
              <ion-icon name="videocam-outline"></ion-icon>
            </div>
            <div className="d-flex w-100 justify-content-between align-items-center">
              <div>New contact</div>
              <span className="text-muted fs-4">
                <ion-icon
                  name="qr-code-outline"
                  className="md hydrated fs-1"
                ></ion-icon>
              </span>
            </div>
          </div>
        </li>
        {/* <li>
          <div className="item">
            <div className="icon-box bg-success">
              <ion-icon name="musical-notes-outline"></ion-icon>
            </div>
            <div className="">
              <div>New Community</div>
            </div>
          </div>
        </li> */}
        {/* Search box for main component */}
        <li>
          <Form.Group className="my-2 ps-3 pe-2">
            <Form.Control
              type="text"
              placeholder="Search Users eg: John, Piyush, Jane"
              value={search}
              onChange={handleMainSearch}
            />
          </Form.Group>
        </li>
        {loadingChat ? (
          <div className="d-flex justify-content-center mt-2">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <label style={{ padding: '8px 19px' }}>
              <b>Users on FirstUpdate</b>
            </label>
            {searchResult.length > 0 ? (
              searchResult.map(user => (
                <li
                  key={user._id}
                  onClick={() => handleFunction(user._id)}
                  style={{ cursor: 'pointer' }}
                  className="hover:bg-gray-400 mb-2"
                >
                  {console.log(user)}
                  <div className="item" style={{ cursor: 'pointer' }}>
                    <div className="position-relative">
                      {user.type == 'bot' ? (
                        <div
                          className="image d-flex align-items-center justify-content-center col-dry"
                          style={{
                            backgroundColor: '#e0e0e0',
                            fontSize: '30px'
                          }}
                        >
                          <ion-icon
                            name="logo-ionitron"
                            style={{ color: '#bdbdbd' }}
                          ></ion-icon>
                        </div>
                      ) : (
                        <img
                          src={user.pic}
                          alt={`${user.name}'s profile`}
                          className="image"
                        />
                      )}
                    </div>
                    <div className="d-flex flex-column">
                      <label className="contact-name">{user.name}</label>
                      <label className="contact-number">
                        {user.type == 'bot'
                          ? user.display
                          : formatPhoneNumber(user.phone)}
                      </label>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li>
                <div className="item text-center text-muted">
                  No users found.
                </div>
              </li>
            )}
          </>
        )}
      </ul>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authToken } = auth
  return { authToken }
}

export default connect(mapStateToProps)(Contacts)
